<template>
    <div v-if="show" class="modal-overlay" @click.self="$emit('close')">
        <div class="modal-container">
            <div class="modal-header">
                <h4 class="p-0 m-0">Supprimer cette plage horaire</h4>
                <button type="button" class="close-button" @click="$emit('close')">
                    <span>&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p>Voulez-vous vraiment supprimer cette plage horaire ?</p>
                <p v-if="timeRange">
                    <strong>Jour:</strong> {{ timeRange.day }}<br>
                    <strong>Horaire:</strong> {{ formatTime(timeRange.start_time) }} - {{ formatTime(timeRange.end_time) }}
                </p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" @click="$emit('close')">
                    Annuler
                </button>
                <button type="button" class="btn btn-danger" @click="$emit('confirm')">
                    Confirmer
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import timeMixin from "../../Mixins/appointmentsMixin";

export default {
    name: "DeleteConfirmationModal",
    mixins: [timeMixin],
    props: {
        show: {
            type: Boolean,
            default: false
        },
        timeRange: {
            type: Object,
            default: null
        },
    }
}
</script>
